import type { CommonProps } from 'gooey';

export interface FormFieldError {
  message: string;
}

export interface FormFieldErrorProps extends CommonProps<HTMLDivElement> {
  errors?: Array<FormFieldError | undefined>;
}

export function FormFieldError({ errors, ...props }: FormFieldErrorProps) {
  const errorMessage = errors
    ?.filter((error) => error?.message)
    .map((error) => error?.message)
    .join(',');

  if (!errorMessage) {
    return null;
  }

  return (
    <div className='text-error-main' {...props}>
      {errorMessage}
    </div>
  );
}
